import * as React from 'react'
import Svg, { Line, Rect, SvgProps } from 'react-native-svg'

export const Board = (props: SvgProps) => (
  <Svg viewBox='0 0 11 15' fill='none' {...props}>
    <Rect x='0.5' y='0.5' width='10' height='14' rx='0.5' stroke='currentColor' />
    <Rect x='3.5' y='0.5' width='4' height='2' rx='0.5' stroke='currentColor' />
    <Line x1='2' y1='5.5' x2='9' y2='5.5' stroke='currentColor' />
    <Line x1='2' y1='8.5' x2='9' y2='8.5' stroke='currentColor' />
  </Svg>
)
